import { SCREEN_SIZE } from 'src/app/core/constants/screen-size';
import { Component, OnInit, ViewChild, OnDestroy, ViewChildren, AfterViewInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Router, ActivatedRoute } from '@angular/router';

import { BranchService } from 'src/app/core/services/branch.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import { Subscription } from 'rxjs';
import { CommonService } from 'src/app/core/services/common.service';
import { WarningComponent } from 'src/app/shared/components/warning/warning.component';
import { Message } from 'src/app/core/class/message';
import { ToastrService } from 'ngx-toastr';
import { MatSelect } from '@angular/material';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ResponsiveService } from '../../../../../core/services/responsive.service';
import { ErrorCode } from 'src/app/core/constants/error-code';

@Component({
  selector: 'app-branch',
  templateUrl: './branch.component.html'
})
export class BranchComponent implements OnInit, OnDestroy, AfterViewInit {
  isTableLoading = false;
  branch = {
    enterprise: {
      status: 'null',
      keyword: ''
    },
    addresses: [
      {
        cityId: null,
        wardId: null,
        districtId: null,
        address: ''
      }
    ]
  };
  checkFocus = true;
  oldData = this.branch;
  // displayedColumns: string[] = ['id', 'name', 'taxCode', 'representative', 'email', 'phone', 'status', 'settings'];

  displayedColumns: string[] = [];

  columnDefinitions = [
    { def: "id", showMobile: true },
    { def: "name", showMobile: false },
    { def: "taxCode", showMobile: true },
    { def: "certificateNo", showMobile: false },
    { def: "representative", showMobile: false },
    { def: "email", showMobile: false },
    { def: "phone", showMobile: false },
    { def: "status", showMobile: true },
    { def: "action", showMobile: true },
  ];

  dataSource = new MatTableDataSource();
  paginate: {
    currentPage: number,
    pageSize: number,
    totalRow: number,
    totalPage: number,
    totalPageArray: [],
    no: []
  };
  error = '';
  subscription: Subscription;
  cities: { id: number, name: '', description: '' }[];
  districts: { id: number, cityId: number, name: '', description: '' }[];
  wards: { id: number, districtId: number, name: '', description: '' }[];

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChildren('focusInput') focusInput;
  @ViewChild('statusSelect', { static: false }) statusSelect: MatSelect;

  public mediaBreakpoint: any;
  public subscribeMediaBreakPointService: Subscription;
  public SCREEN_SIZE = SCREEN_SIZE;

  constructor(
    public notificationService: NotificationService,
    public dialog: MatDialog,
    private branchService: BranchService,
    public commonService: CommonService,
    private route: ActivatedRoute,
    private router: Router,
    private message: Message,
    private toastr: ToastrService,
    private responsiveService: ResponsiveService,
  ) {
    this.paginate = {
      currentPage: 0,
      pageSize: 10,
      totalRow: 0,
      totalPage: 0,
      totalPageArray: [],
      no: []
    };
  }

  /**
   * Get initial data
   */
  ngOnInit() {
    this.loadData(this.paginate.currentPage, this.paginate.pageSize);
    this.notificationService.subscribeErrorService();
  }

  ngAfterViewInit() {
    setTimeout(_ => this.focusInput.first.nativeElement.focus());
    this.subscribeMediaBreakPointService = this.responsiveService._getMediaBreakpoint().subscribe(
      media => {
        if (media === '') {
          this.mediaBreakpoint = '';
          return;
        } else {
          this.mediaBreakpoint = media;
          this.getDisplayedColumns();
        }
      }
    );
  }

  /**
   * Implement ngOnDestroy method, unsubscribe error service to avoid memory leak
   */
  ngOnDestroy() {
    this.notificationService.unsubscribeErrorService();
    this.subscribeMediaBreakPointService.unsubscribe();
  }

  /**
   * Load all customer, lazy loading
   * @param page: number
   * @param pageSize: number
   */
  loadData(page: number = 0, pageSize: number = 10) {
    let tempTenantId: any;
    let paramName: '';
    let paramStatus: [];
    let paramTaxCode: '';
    let paramKeyword: '';

    this.subscription = this.route
      .queryParams
      .subscribe(params => {
        tempTenantId = params.tenantId;
        // Defaults to 0 if no query param provided.
        if (typeof tempTenantId !== 'undefined') {
          page = params.page || 0;
          pageSize = params.pageSize || 0;
          paramName = params.name || '';
          paramKeyword = params.keyword || '';
          paramStatus = params.status.split(',');
          paramTaxCode = params.taxCode || '';
        }
      });


    if (typeof tempTenantId !== 'undefined') {
      this.branch.enterprise.keyword = paramKeyword;
      this.branch.enterprise.status = paramStatus.length > 1 ? 'null' : paramStatus.toString();
    }

    this.isTableLoading = true;
    // clear data cu: skeleton la footer-row nam duoi cung bang, neu giu data cu thi no nam
    // duoi man hinh -> clear de skeleton hien ngay duoi header nhu luc vua vao trang
    this.dataSource.data = [];
    this.branchService.filterBranches({
      tenantId: localStorage.getItem('tenantId'),
      page,
      pageSize,
      parentId: localStorage.getItem('enterpriseId'),
      keyword: typeof tempTenantId !== 'undefined' ? paramKeyword : '',
      status: typeof tempTenantId !== 'undefined' ? paramStatus : [true, false],
    }).subscribe(
      rs => {
        this.isTableLoading = false;
        if (rs == null || rs.data == null || rs.data.dataRow == null) {
          return 0;
        }
        this.paginate = {
          currentPage: rs.data.currentPage,
          pageSize: rs.data.pageSize,
          totalRow: rs.data.totalRow,
          totalPage: Math.ceil(rs.data.totalRow / rs.data.pageSize),
          totalPageArray: this.commonService.counter(Math.ceil(rs.data.totalRow / rs.data.pageSize), 1),
          no: this.commonService.counter(rs.data.pageSize, rs.data.currentPage * rs.data.pageSize + 1)
        };
        this.dataSource.data = rs.data.dataRow;
        if (this.cities !== undefined && this.districts !== undefined && this.wards !== undefined) {
          this.dataSource.data = this.dataSource.data.map((x: any) => {
            return {
              ...x,
              address: x.address + ` - ${this.commonService.getWardName(this.wards, x.wardId).name} - ${this.commonService.getDistrictName(this.districts, x.districtId).name} - ${this.commonService.getCityName(this.cities, x.cityId).name}`
            };
          });
        }
      }, () => this.isTableLoading = false
    );
  }

  getDisplayedColumns() {
    if (this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM) {
      this.displayedColumns = this.columnDefinitions
        .filter(cd => cd.showMobile)
        .map(cd => cd.def);
    } else {
      this.displayedColumns = this.columnDefinitions.map(cd => cd.def);
    }
    // if (this.commonService.getIsLockedEnterprise()) {
    //   this.displayedColumns = this.columnDefinitions
    //     .filter(cd => (cd.def !== 'action' && cd.def !== 'status'))
    //     .map(cd => cd.def);
    // }
  }

  /**
   * On click button change branch status
   */

  onClickIconChangeStatus(branchId: number, branchName: string, branchStatus: boolean) {
    // them trang thai cua chi nhanh
    var s1 = branchStatus ? '<strong>' + this.message.getMessage('enterprise_branch_management.cbx_branch_status.cbx_branch_status_active') + '</strong>'
      : '<strong>' + this.message.getMessage('enterprise_branch_management.cbx_branch_status.cbx_branch_status_inactive') + '</strong>';

    var s2 = !branchStatus ? '<strong>' + this.message.getMessage('enterprise_branch_management.cbx_branch_status.cbx_branch_status_active') + '</strong>'
      : '<strong>' + this.message.getMessage('enterprise_branch_management.cbx_branch_status.cbx_branch_status_inactive') + '</strong>';

    const dialogRef = this.dialog.open(WarningComponent, {
      width: '350px',
      //them ten chi nhanh
      data: this.commonService.format(this.message.getMessage('messages.confirm_change_status_branch'), branchName,s1,s2)
    });
    dialogRef.afterClosed().subscribe(rs => {
      if (rs) {
        this.branchService.changeBranchStatus(branchId).subscribe(
          () => {
            this.toastr.success(this.message.getMessage('messages.update_status_success'));
            if (this.paginate.totalRow % this.paginate.pageSize === 1) {
              if (this.paginate.currentPage - 1 < 0) {
                this.paginate.currentPage = 0;
              } else {
                this.paginate.currentPage = this.paginate.currentPage - 1;
              }
            }
            this.onFilterBranches(this.paginate.currentPage, this.paginate.pageSize);
          }
        );
      }
    });
  }

  /**
   * Filter branches
   */
  onFilterBranches(page: number = 0, pageSize: number = 10) {
    let status;
    if (this.oldData.enterprise.status == null || this.oldData.enterprise.status === 'null') {
      status = [true, false];
    } else {
      status = [this.oldData.enterprise.status === 'true'];
    }

    // // changes the route without moving from the current view or
    // // triggering a navigation event,
    // this.router.navigate([], {
    //   relativeTo: this.route,
    //   queryParams: {
    //     tenantId: localStorage.getItem('tenantId'),
    //     page,
    //     pageSize,
    //     parentId: localStorage.getItem('enterpriseId'),
    //     keyword: this.oldData.enterprise.keyword,
    //     status: status.toString()
    //   }
    // });

    this.isTableLoading = true;
    // clear data cu: skeleton la footer-row nam duoi cung bang, neu giu data cu thi no nam
    // duoi man hinh -> clear de skeleton hien ngay duoi header nhu luc vua vao trang
    this.dataSource.data = [];
    this.branchService.filterBranches({
      tenantId: localStorage.getItem('tenantId'),
      page,
      pageSize,
      parentId: localStorage.getItem('enterpriseId'),
      keyword: this.oldData.enterprise.keyword,
      status
    }).subscribe(
      rs => {
        this.isTableLoading = false;
        if (rs == null || rs.data == null || rs.data.dataRow == null) {
          if(rs.code == ErrorCode.BranchNotPermission) {
            this.toastr.error(this.message.getMessage('messages.no_permission'));
          }
          return;
        }
        this.paginate = {
          currentPage: rs.data.currentPage,
          pageSize: rs.data.pageSize,
          totalRow: rs.data.totalRow,
          totalPage: Math.ceil(rs.data.totalRow / rs.data.pageSize),
          totalPageArray: this.commonService.counter(Math.ceil(rs.data.totalRow / rs.data.pageSize), 1),
          no: this.commonService.counter(rs.data.pageSize, rs.data.currentPage * rs.data.pageSize + 1)
        };
        this.dataSource.data = rs.data.dataRow;
        if (this.cities !== undefined && this.districts !== undefined && this.wards !== undefined) {
          this.dataSource.data = this.dataSource.data.map((x: any) => {
            return {
              ...x,
              address: x.address + ` - ${this.commonService.getWardName(this.wards, x.wardId).name} -
                                      ${this.commonService.getDistrictName(this.districts, x.districtId).name} -
                                      ${this.commonService.getCityName(this.cities, x.cityId).name}`
            };
          });
        }
      }, () => this.isTableLoading = false
    );
  }

  /**
   * Bind old search data to variable oldData to avoid error
   */
  onClickBtnFilter() {
    this.oldData = { ...this.branch };
  }

  /**
   *
   */
  onClickBtnView(route: string, id: string) {
    let status;
    if (this.oldData.enterprise.status == null || this.oldData.enterprise.status === 'null') {
      status = [true, false];
    } else {
      status = [this.oldData.enterprise.status === 'true'];
    }

    // changes the route without moving from the current view or
    // triggering a navigation event,
    this.router.navigate([route + id], {
      queryParams: {
        tenantId: localStorage.getItem('tenantId'),
        page: this.paginate.currentPage,
        pageSize: this.paginate.pageSize,
        parentId: localStorage.getItem('enterpriseId'),
        status: status.toString(),
        keyword: this.oldData.enterprise.keyword
      }
    });
  }
}
